import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import appstore from "../../../assets/icon/appstore.png";
import ggplay from "../../../assets/icon/ggplay.png";
import tick from "../../../assets/icon/tick-02.svg";
import imgE1 from "../../../assets/images/imgE1.png";
import imgE2 from "../../../assets/images/imgE2.png";
import Banner from "../../../components/Banner/Banner";
import { FaChevronDown } from "react-icons/fa";
import DropdownCustom from "../../../components/ui/Dropdown";
import imageBanner from "../../../assets/images/banner.png"
import { ROUTES } from "../../../constants/routers";

const EWallets = () => {
    const navigate = useNavigate();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className="section-top">
            <div className="container">
                <Banner
                    img={imgE1}
                    bgr={imageBanner}
                >
                    <h2 className="fs-1 fw-bold">Sản phẩm - dịch vụ</h2>
                    <p className="fs-6 my-3">HPay cung cấp các giải pháp trung gian thanh toán toàn diện với nhiều dịch vụ và tiện ích cho tất cả khách hàng.</p>
                    <div className="bn-app d-flex gap-3">
                        <a href="https://play.google.com/store/apps/details?id=com.hpay.ewalletapp" target="_blank">
                            <img src={ggplay} alt={'gg'} />
                        </a>
                        <a href="https://apps.apple.com/vn/app/hpay/id6479690061" target="_blank">
                            <img src={appstore} alt={'app'} />
                        </a>
                    </div>
                </Banner>
                <div className="section-top-big">
                    <div className="row">
                        <div className="col-lg-3 d-none d-lg-block">
                            <ul className="list-unstyled">
                                <li>
                                    <Link to={ROUTES.PAYMENT_GATEWAYS} className="link-hover-tab">
                                        Cổng thanh toán
                                    </Link>
                                </li>
                                <li className="mt-2">
                                    <Link to={ROUTES.E_WALLETS} className="link-hover-tab active">
                                        Ví điện tử
                                    </Link>
                                </li>
                                <li className="mt-2">
                                    <Link to={ROUTES.SERVICES} className="link-hover-tab">
                                        Dịch vụ Thu hộ
                                    </Link>
                                </li>
                                <li className="mt-2">
                                    <Link to={ROUTES.FEE_SCHEDULE} className="link-hover-tab">
                                        Biểu phí
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div className="col-lg-9 col-12">
                            <h2 className="fw-bold mt-lg-0 fs-1">Ví điện tử HPay</h2>
                            <div className="d-lg-none">
                                <DropdownCustom items={[
                                    { label: "Cổng thanh toán", value: ROUTES.PAYMENT_GATEWAYS },
                                    { label: "Ví điện tử", value: ROUTES.E_WALLETS },
                                    { label: "Dịch vụ Thu hộ", value: ROUTES.SERVICES },
                                    { label: "Biểu phí", value: ROUTES.FEE_SCHEDULE }
                                ]

                                }
                                    onSelect={(item) => navigate(item.value)}
                                >
                                    <div className="btn-dropdown mt-3">
                                        Ví điện tử
                                        <FaChevronDown className="text-secondary ms-2" />
                                    </div>
                                </DropdownCustom>
                            </div>
                            <p className="desc-1 my-4">
                                Dịch vụ Ví điện tử HPay cung cấp tính năng thanh toán trực tuyến các hóa đơn, dịch vụ phổ biến hiện nay như: thanh
                                toán hóa đơn nước, điện, chuyển tiền qua số điện thoại,... một cách nhanh chóng, tiện lợi và tiết kiệm.
                            </p>
                            <ul className="mb-4 list-unstyled">
                                <li>
                                    <img src={tick} className="me-2" alt="" />
                                    <span className="desc-2">Hỗ trợ thanh toán đa dạng dịch vụ</span>
                                </li>
                                <li className="mt-2">
                                    <img src={tick} className="me-2" alt="" />
                                    <span className="desc-2">Giao dịch tự động, nhanh chóng</span>
                                </li>
                                <li className="mt-2">
                                    <img src={tick} className="me-2" alt="" />
                                    <span className="desc-2">Dữ liệu mã hóa, bảo mật</span>
                                </li>
                                <li className="mt-2">
                                    <img src={tick} className="me-2" alt="" />
                                    <span className="desc-2">Hỗ trợ hơn 40 thẻ ngân hàng ATM nội địa và thẻ ghi nợ quốc tế</span>
                                </li>
                            </ul>
                            <div className="my-5">
                                <div data-aos="fade-up-left">
                                    <img src={imgE2} className="img-fluid" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EWallets;
